// Animated brand logo: rotating Earth (SVG) behind a gold "AR" monogram.
// Pure CSS animation, no images, ultra crisp at every size.
export default function Logo({ size = 44, withText = true, dark = false }) {
  const text = dark ? "text-[#F9F8F6]" : "text-[#1A1B1A]";
  const sub = dark ? "text-[#D4AF37]/85" : "text-[#4A4D4A]";
  return (
    <div className="flex items-center gap-3 group">
      <div
        className="relative shrink-0 rounded-full overflow-hidden"
        style={{ width: size, height: size }}
        aria-label="AR Overseas — global trade logo"
      >
        {/* Royal radial backdrop */}
        <div className="absolute inset-0 rounded-full"
             style={{ background: "radial-gradient(circle at 30% 30%, #2C4532 0%, #16291C 70%, #0d1d12 100%)" }} />

        {/* Spinning earth lattice (longitudes + meridian) */}
        <svg
          viewBox="0 0 100 100"
          className="absolute inset-0 w-full h-full animate-globe"
          fill="none"
          stroke="rgba(212,175,55,0.55)"
          strokeWidth="0.6"
        >
          <circle cx="50" cy="50" r="38" />
          <ellipse cx="50" cy="50" rx="38" ry="14" />
          <ellipse cx="50" cy="50" rx="38" ry="26" />
          <ellipse cx="50" cy="50" rx="14" ry="38" />
          <ellipse cx="50" cy="50" rx="26" ry="38" />
        </svg>

        {/* Counter-rotating subtle dotted orbit */}
        <svg
          viewBox="0 0 100 100"
          className="absolute inset-0 w-full h-full animate-globe-slow"
          fill="none"
          stroke="rgba(212,175,55,0.35)"
          strokeWidth="0.35"
          strokeDasharray="1.2 2.2"
        >
          <circle cx="50" cy="50" r="44" />
        </svg>

        {/* Gold rim */}
        <div className="absolute inset-0 rounded-full ring-1 ring-[#D4AF37]/70" />

        {/* AR monogram */}
        <div className="absolute inset-0 flex items-center justify-center">
          <span
            className="font-serif font-semibold tracking-tighter leading-none"
            style={{
              fontSize: size * 0.46,
              background: "linear-gradient(135deg,#F4D77E 0%,#D4AF37 60%,#B8941F 100%)",
              WebkitBackgroundClip: "text",
              backgroundClip: "text",
              color: "transparent",
              textShadow: "0 1px 0 rgba(0,0,0,0.25)",
            }}
          >
            AR
          </span>
        </div>
      </div>

      {withText && (
        <div className="leading-tight">
          <div className={`font-serif text-[15px] md:text-[17px] tracking-[0.04em] ${text}`}>
            AR Overseas Exports
          </div>
          <div className={`text-[9px] md:text-[10px] uppercase tracking-[0.32em] ${sub}`}>
            Pioneering Global Trade
          </div>
        </div>
      )}
    </div>
  );
}
